
import { defineComponent, ref, reactive, computed, onMounted, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({

    props: {
        title: {
            type: String,
            default: 'Form',
        },
        id: {
            type: String,
            required: true
        },
    },

    setup(props) 
    {
        const form = reactive({
            id: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            employee_number: '',
            email: '',
            role_id: '',
            business_unit_id: '',
        })
        const name = ref('Business Unit Admin User')
        const store = useStore()
        const router = useRouter()

        const business_units = ref([])
        const roles = ref([])
        const form_action = ref('save')

        onMounted(() => {
            if(props.id) {
                form_action.value = 'update'
                showUser()
            } else {
                form_action.value = 'save'
            }
            getTypes()
        })

        const showUser = () => {
            store.dispatch('User/show', props.id).then((res:any) => {
                const { id, first_name, middle_name, last_name, email, employee_number, role_id, business_unit_id } = toRefs(form)
                id.value = res.data.id;
                first_name.value = res.data.first_name;
                middle_name.value = res.data.middle_name;
                last_name.value = res.data.last_name;
                email.value = res.data.email;
                employee_number.value = res.data.employee_number;
                role_id.value = res.data.role.id;
                business_unit_id.value = res.data.business_unit.id;
                console.log(res.data)
            })
        }

        const getTypes = () => {
            store.dispatch('BusinessUnit/index').then((res) => {
                business_units.value = res.data.data
            })
            store.dispatch('Role/index').then((res) => {
                roles.value = res.data.data
            })
        }

        const back = () => {
            router.go(-1) 
        }

        const handleSaving =() => {
            form_action.value == 'save' ? storeRecord() : updateRecord()
        }

        const storeRecord = () => {
            store.dispatch('BusinessUnitAdmin/store', form).then((res:any) => {
                if(res.data) {
                    back()
                }
            })
        }

        const updateRecord = () => {
            store.dispatch('BusinessUnitAdmin/update', form).then((res:any) => {
                if(res.data) {
                    back()
                }
            })
        }

        const filterOption = (
            input: string,
            option: { children: { children: string }[] }
            ) => {
            return (
                option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        };
        

        return {
            form,
            back,
            business_units,
            roles,
            name,
            handleSaving,
            filterOption,
        }
    }
})
